export const formatImageSize = size => {
    const mb = Math.round(size * 10 / 1024**2 + Number.EPSILON) / 10;
    const kb = Math.round(size / 1024 + Number.EPSILON);
    return mb > 0 ? mb.toString() + " MB" : kb.toString() + " KB";
}